import React, { Component, Fragment } from "react";
import { push } from "connected-react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Logout from "../views/auth/Logout";
import { images } from "../helpers/images";
import LogoutConfirmationModal from "./modals/LogoutConfirmationModal";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      showModal: false,
    };
  }

  onShowModal = () => {
    this.setState({ showModal: true });
  };

  onCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { showModal } = this.state;

    return (
      <Fragment>
        <div id="sidebar" className="cell small-12 medium-2">
          <div id="logo" className="">
            <img src={images.logo} />
            <p id="logodesc">
              SAQ Generator
              <br />
              BETA
            </p>
          </div>
          <ul className="vertical menu sidebar-menu">
            <li>
              <Link to="/dashboard" className="current">
                <span className="menu-icn dashboard"></span>Dashboard
              </Link>
            </li>
            <li>
              <Link to="/create/wizard">
                <span className="menu-icn wizard"></span> SAQ Wizard
              </Link>
            </li>
            <li>
              <Link to="/completed-saqs">
                <span className="menu-icn completed"></span> Completed SAQs
              </Link>
            </li>
            <li>
              <a onClick={() => this.onShowModal()}>
                <span className="menu-icn logout"></span> Logout
              </a>
            </li>
          </ul>
        </div>

        <LogoutConfirmationModal
          history={this.props.history}
          showModal={showModal}
          onCloseModal={() => this.onCloseModal()}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
